export const BACKGROUND_TYPE_SQUARE = 1;
export const BACKGROUND_TYPE_CIRCLE = 2;
export const BACKGROUND_TYPE_NONE = 3;
